export default "__VITE_ASSET__BiA80UFE__"